import { ReceiptPercentIcon } from "@heroicons/react/24/solid";
import React from "react";
import { TotalInvoiceApprovedCard } from "../cards/TotalInvoiceApprovedCard";
import { TotalNumberInvoicesCard } from "../cards/TotalNumberInvoicesCard";
import { ActiveInvoiceDetails } from "./ActiveInvoiceDetails";
import { MyTasksDetails } from "./MyTasksDetails";

interface Props {}

export const VendorInvoiceTable: React.FC<Props> = () => {
  return (
    <>
      <div className="flex gap-2 items-center">
        <div>
          <ReceiptPercentIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
        </div>
        <div className="flex flex-col leading tight">
          <h3 className="text-xs font-medium text-gray-500">
            Vendor Invoice Processing
          </h3>
          <h1 className="mr-auto font-bold text-primary text-md uppercase">
            Invoice Manager
          </h1>
        </div>
      </div>
      <div className="w-full bg-white p-4 overflow-x-auto box-shadow rounded mb-2 mt-2">
        <ActiveInvoiceDetails />
      </div>
      <div className="flex flex-row gap-3">
        <div className="w-full bg-white p-4 overflow-x-auto box-shadow rounded">
          <MyTasksDetails />
        </div>
        <div className="flex flex-col justify-between gap-2">
          <TotalNumberInvoicesCard />
          <TotalInvoiceApprovedCard />
        </div>
      </div>
    </>
  );
};
